import { defineComponent, h, provide, renderSlot } from 'vue'
import { useNamespace } from '@sgui-plus/hooks'

const Timeline = defineComponent({
  name: 'SgTimeline',
  props: {
    horizontal: {
      type: Boolean,
      default: false
    }
  },
  setup(props, { slots }) {
    const ns = useNamespace('timeline')

    provide('TimelineContextKey', { props, slots })

    return () => {
      return h('ul', { class: [ns.b(), props.horizontal && 'is-horizontal'] }, [renderSlot(slots, 'default')])
    }
  },
})

export default Timeline
export type TimelineInstance = InstanceType<typeof Timeline>
